/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditLogListRequest {
    getFixupPrototypeFunction() { return AuditLogListRequest.fixupPrototype; }

    static newInstance(model: Partial<AuditLogListRequest>): AuditLogListRequest {
        let obj = Object.assign(new AuditLogListRequest(), model);
        AuditLogListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditLogListRequest>): AuditLogListRequest {
        if (!model) return null;
        return AuditLogListRequest.newInstance(<AuditLogListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditLogListRequest) {
        if (!obj) return;

        models.AuditLogListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditLogListRequest): boolean {
        Object.setPrototypeOf(obj, AuditLogListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AuditLogFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AuditLogDocumentSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AuditLogDocumentSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AuditLogFilters;

}
